import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  root: {
    minHeight: 560,
    width: 850,
    backgroundColor: '#fff',
    borderRadius: 12,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      minHeight: 'unset'
    }
  },
  detailBox: {
    paddingLeft: 55,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0
    }
  }
}))
